/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Footer_PlaceholderInputs */

const vi_invoice_footer_placeholder = /** @type {(inputs: Invoice_Footer_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cảm ơn quý khách...`)
};

/**

* @param {Invoice_Footer_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_footer_placeholder = /** @type {((inputs?: Invoice_Footer_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Footer_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_footer_placeholder(inputs)
});